import { SparklesFilled } from '@wix/wix-ui-icons-common';
import React from 'react';

export const AiIcon: React.FC = () => {
  return <SparklesFilled fill="currentColor" />;
};
